<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Tag de Produção' : 'Nova Tag de Produção' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} a tag.
                        </p>
                    </div>
                </div>
            </div>
            @if(isLoading) {
            <div class="col-12"><app-loading-box height="200"></app-loading-box></div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="tag-form-preview-layout">
                        <div class="tag-form-col">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Descrição</mat-label>
                                <input matInput formControlName="descricao" placeholder="Digite a descrição da tag"
                                    required>
                                @if (form.get('descricao')?.hasError('required')) {
                                <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
                                }
                            </mat-form-field>

                            <div class="color-picker-wrapper">
                                <label class="color-label">Cor</label>
                                <div class="color-picker-row">
                                    <input type="color" formControlName="cor" class="color-input"
                                        (input)="onColorChange($event)">
                                    <input type="text" formControlName="cor" class="color-text-input"
                                        placeholder="#000000" maxlength="7" (input)="onColorChange($event)">
                                </div>
                            </div>
                        </div>
                        <div class="tag-form-col">
                            <div class="section-title">
                                <mat-icon>visibility</mat-icon>
                                <span>Pré-visualização</span>
                            </div>
                            <div class="tag-preview-row">
                                <div class="tag-preview-card tag-preview-light">
                                    <span class="tag-preview-caption">Modo claro</span>
                                    <app-ui-tag [text]="form.get('descricao')?.value || 'Preview'"
                                        [bgColor]="form.get('cor')?.value"></app-ui-tag>
                                </div>
                                <div class="tag-preview-card tag-preview-dark">
                                    <span class="tag-preview-caption">Modo escuro</span>
                                    <app-ui-tag [text]="form.get('descricao')?.value || 'Preview'"
                                        [bgColor]="form.get('cor')?.value"></app-ui-tag>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>
<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
